// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/tool/v1/remote.proto" (package "agency.tool.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { ToolCall } from "./tool";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { ExecutionMode } from "./tool";
import { ToolDescriptor } from "./tool";
import { URN } from "../../urn/v1/urn";
/**
 * ToolRegistrationRequest registers a remote tool instance with the harness.
 * Published to tool.register.<tenant>.<workspace> (req/reply).
 *
 * @generated from protobuf message agency.tool.v1.ToolRegistrationRequest
 */
export interface ToolRegistrationRequest {
    /**
     * harness_urn is the harness instance this tool is registering with.
     * Format: urn.<region>.<kind>.<instance>.<tenant>.<workspace>._.harness
     *
     * @generated from protobuf field: agency.urn.v1.URN harness_urn = 1
     */
    harnessUrn?: URN;
    /**
     * descriptor is the tool metadata.
     *
     * @generated from protobuf field: agency.tool.v1.ToolDescriptor descriptor = 2
     */
    descriptor?: ToolDescriptor;
    /**
     * preferred_mode is the tool's preferred execution mode.
     * Harness selects final mode based on config and tool preference.
     *
     * @generated from protobuf field: agency.tool.v1.ExecutionMode preferred_mode = 3
     */
    preferredMode: ExecutionMode;
    /**
     * process_id uniquely identifies this tool process instance.
     * Used in URN construction: urn.<...>.<workspace>.<session>.<tool_name>.<process_id>
     *
     * @generated from protobuf field: string process_id = 4
     */
    processId: string;
    /**
     * version is the tool implementation version (semver).
     *
     * @generated from protobuf field: string version = 5
     */
    version: string;
    /**
     * metadata contains tool-specific registration metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 6
     */
    metadata: {
        [key: string]: string;
    };
    /**
     * location is the provider's free-form location label (e.g. "machine-a", "us-east-1").
     * Must satisfy [a-z0-9][a-z0-9_-]*[a-z0-9] — safe as NATS subject token and KV key component.
     * Required when registering tools that share a name with tools from other providers.
     *
     * @generated from protobuf field: string location = 7
     */
    location: string;
}
/**
 * ToolRegistrationAck confirms tool registration.
 * Returned as reply to ToolRegistrationRequest.
 *
 * @generated from protobuf message agency.tool.v1.ToolRegistrationAck
 */
export interface ToolRegistrationAck {
    /**
     * tool_urn is the assigned URN for this tool instance.
     * Format: urn.<region>.<kind>.<instance>.<tenant>.<workspace>.tool.<tool_name>.<process_id>
     * session field is the reserved sentinel "tool" for all workspace-scoped tool instances.
     * actor = tool_name, sub_path[0] = process_id. See bridge.ToolInstanceURN().
     *
     * @generated from protobuf field: agency.urn.v1.URN tool_urn = 1
     */
    toolUrn?: URN;
    /**
     * selected_mode is the execution mode the harness selected.
     *
     * @generated from protobuf field: agency.tool.v1.ExecutionMode selected_mode = 2
     */
    selectedMode: ExecutionMode;
    /**
     * heartbeat_interval_seconds is how often the tool must send heartbeats.
     *
     * @generated from protobuf field: int32 heartbeat_interval_seconds = 3
     */
    heartbeatIntervalSeconds: number;
    /**
     * execution_subject is the subject the tool should subscribe to (SYNC mode).
     * Format: tool.exec.<tenant>.<workspace>.<tool_name>
     *
     * @generated from protobuf field: string execution_subject = 4
     */
    executionSubject: string;
    /**
     * request_stream is the JetStream stream to consume from (ASYNC mode).
     * Format: tool-requests_<tenant>_<workspace>
     *
     * @generated from protobuf field: string request_stream = 5
     */
    requestStream: string;
    /**
     * registered_at is when registration completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp registered_at = 6
     */
    registeredAt?: Timestamp;
}
/**
 * ToolHeartbeat maintains tool liveness.
 * Published to tool.heartbeat.<tenant>.<workspace>.<tool_name>.<process_id>
 *
 * @generated from protobuf message agency.tool.v1.ToolHeartbeat
 */
export interface ToolHeartbeat {
    /**
     * tool_urn is the tool instance URN.
     *
     * @generated from protobuf field: agency.urn.v1.URN tool_urn = 1
     */
    toolUrn?: URN;
    /**
     * timestamp is when the heartbeat was sent.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 2
     */
    timestamp?: Timestamp;
    /**
     * status indicates tool health.
     *
     * @generated from protobuf field: agency.tool.v1.ToolStatus status = 3
     */
    status: ToolStatus;
    /**
     * active_calls is the number of currently executing calls.
     *
     * @generated from protobuf field: int32 active_calls = 4
     */
    activeCalls: number;
    /**
     * metadata contains tool-specific health metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 5
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * RemoteToolExecutionRequest dispatches a tool call to a remote tool.
 * Published to tool.exec.<tenant>.<workspace>.<tool_name> (SYNC)
 * or tool-requests_<tenant>_<workspace> stream (ASYNC).
 *
 * @generated from protobuf message agency.tool.v1.RemoteToolExecutionRequest
 */
export interface RemoteToolExecutionRequest {
    /**
     * tool_urn is the target tool instance URN.
     *
     * @generated from protobuf field: agency.urn.v1.URN tool_urn = 1
     */
    toolUrn?: URN;
    /**
     * harness_urn is the originating harness URN.
     *
     * @generated from protobuf field: agency.urn.v1.URN harness_urn = 2
     */
    harnessUrn?: URN;
    /**
     * call is the tool call to execute.
     * Contains: id, name, arguments (JSON string).
     *
     * @generated from protobuf field: agency.tool.v1.ToolCall call = 3
     */
    call?: ToolCall;
    /**
     * session_id is the session this call belongs to.
     *
     * @generated from protobuf field: string session_id = 4
     */
    sessionId: string;
    /**
     * turn_id is the turn this call belongs to.
     *
     * @generated from protobuf field: string turn_id = 5
     */
    turnId: string;
    /**
     * timeout_seconds is the execution timeout.
     *
     * @generated from protobuf field: int32 timeout_seconds = 6
     */
    timeoutSeconds: number;
    /**
     * response_subject is where to publish the result (ASYNC mode only).
     * Format: tool.response.<tenant>.<workspace>.<session>.<call_id>
     *
     * @generated from protobuf field: string response_subject = 7
     */
    responseSubject: string;
    /**
     * trace_id links to distributed trace.
     *
     * @generated from protobuf field: string trace_id = 8
     */
    traceId: string;
    /**
     * metadata contains request-specific context.
     *
     * @generated from protobuf field: map<string, string> metadata = 9
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * ToolDeregistrationRequest cleanly removes a tool from the registry.
 * Published to tool.deregister.<tenant>.<workspace>.<tool_name>.<process_id>
 *
 * @generated from protobuf message agency.tool.v1.ToolDeregistrationRequest
 */
export interface ToolDeregistrationRequest {
    /**
     * tool_urn is the tool instance to deregister.
     *
     * @generated from protobuf field: agency.urn.v1.URN tool_urn = 1
     */
    toolUrn?: URN;
    /**
     * reason explains why the tool is deregistering.
     *
     * @generated from protobuf field: string reason = 2
     */
    reason: string;
    /**
     * timestamp is when deregistration was initiated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 3
     */
    timestamp?: Timestamp;
}
/**
 * ToolDeregistrationAck confirms deregistration.
 *
 * @generated from protobuf message agency.tool.v1.ToolDeregistrationAck
 */
export interface ToolDeregistrationAck {
    /**
     * tool_urn is the deregistered tool URN.
     *
     * @generated from protobuf field: agency.urn.v1.URN tool_urn = 1
     */
    toolUrn?: URN;
    /**
     * deregistered_at is when deregistration completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deregistered_at = 2
     */
    deregisteredAt?: Timestamp;
}
/**
 * ToolStatus indicates tool health.
 *
 * @generated from protobuf enum agency.tool.v1.ToolStatus
 */
export enum ToolStatus {
    /**
     * TOOL_STATUS_UNSPECIFIED is invalid.
     *
     * @generated from protobuf enum value: TOOL_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * TOOL_STATUS_HEALTHY — tool is operational.
     *
     * @generated from protobuf enum value: TOOL_STATUS_HEALTHY = 1;
     */
    HEALTHY = 1,
    /**
     * TOOL_STATUS_DEGRADED — tool is operational but impaired.
     *
     * @generated from protobuf enum value: TOOL_STATUS_DEGRADED = 2;
     */
    DEGRADED = 2,
    /**
     * TOOL_STATUS_DRAINING — tool is shutting down gracefully.
     *
     * @generated from protobuf enum value: TOOL_STATUS_DRAINING = 3;
     */
    DRAINING = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class ToolRegistrationRequest$Type extends MessageType<ToolRegistrationRequest> {
    constructor() {
        super("agency.tool.v1.ToolRegistrationRequest", [
            { no: 1, name: "harness_urn", kind: "message", T: () => URN, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "descriptor", kind: "message", T: () => ToolDescriptor, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "preferred_mode", kind: "enum", T: () => ["agency.tool.v1.ExecutionMode", ExecutionMode, "EXECUTION_MODE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "process_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 5, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "32", pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+(-[a-z0-9.-]+)?(\\+[a-z0-9.-]+)?$" } } } },
            { no: 6, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } },
            { no: 7, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolRegistrationRequest>): ToolRegistrationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.preferredMode = 0;
        message.processId = "";
        message.version = "";
        message.metadata = {};
        message.location = "";
        if (value !== undefined)
            reflectionMergePartial<ToolRegistrationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolRegistrationRequest): ToolRegistrationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.urn.v1.URN harness_urn */ 1:
                    message.harnessUrn = URN.internalBinaryRead(reader, reader.uint32(), options, message.harnessUrn);
                    break;
                case /* agency.tool.v1.ToolDescriptor descriptor */ 2:
                    message.descriptor = ToolDescriptor.internalBinaryRead(reader, reader.uint32(), options, message.descriptor);
                    break;
                case /* agency.tool.v1.ExecutionMode preferred_mode */ 3:
                    message.preferredMode = reader.int32();
                    break;
                case /* string process_id */ 4:
                    message.processId = reader.string();
                    break;
                case /* string version */ 5:
                    message.version = reader.string();
                    break;
                case /* map<string, string> metadata */ 6:
                    this.binaryReadMap6(message.metadata, reader, options);
                    break;
                case /* string location */ 7:
                    message.location = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: ToolRegistrationRequest["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ToolRegistrationRequest["metadata"] | undefined, val: ToolRegistrationRequest["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.tool.v1.ToolRegistrationRequest.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ToolRegistrationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.urn.v1.URN harness_urn = 1; */
        if (message.harnessUrn)
            URN.internalBinaryWrite(message.harnessUrn, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.tool.v1.ToolDescriptor descriptor = 2; */
        if (message.descriptor)
            ToolDescriptor.internalBinaryWrite(message.descriptor, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* agency.tool.v1.ExecutionMode preferred_mode = 3; */
        if (message.preferredMode !== 0)
            writer.tag(3, WireType.Varint).int32(message.preferredMode);
        /* string process_id = 4; */
        if (message.processId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.processId);
        /* string version = 5; */
        if (message.version !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.version);
        /* map<string, string> metadata = 6; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* string location = 7; */
        if (message.location !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.location);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolRegistrationRequest
 */
export const ToolRegistrationRequest = new ToolRegistrationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolRegistrationAck$Type extends MessageType<ToolRegistrationAck> {
    constructor() {
        super("agency.tool.v1.ToolRegistrationAck", [
            { no: 1, name: "tool_urn", kind: "message", T: () => URN, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "selected_mode", kind: "enum", T: () => ["agency.tool.v1.ExecutionMode", ExecutionMode, "EXECUTION_MODE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "heartbeat_interval_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 300, gte: 5 } } } },
            { no: 4, name: "execution_subject", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 5, name: "request_stream", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 6, name: "registered_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ToolRegistrationAck>): ToolRegistrationAck {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.selectedMode = 0;
        message.heartbeatIntervalSeconds = 0;
        message.executionSubject = "";
        message.requestStream = "";
        if (value !== undefined)
            reflectionMergePartial<ToolRegistrationAck>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolRegistrationAck): ToolRegistrationAck {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.urn.v1.URN tool_urn */ 1:
                    message.toolUrn = URN.internalBinaryRead(reader, reader.uint32(), options, message.toolUrn);
                    break;
                case /* agency.tool.v1.ExecutionMode selected_mode */ 2:
                    message.selectedMode = reader.int32();
                    break;
                case /* int32 heartbeat_interval_seconds */ 3:
                    message.heartbeatIntervalSeconds = reader.int32();
                    break;
                case /* string execution_subject */ 4:
                    message.executionSubject = reader.string();
                    break;
                case /* string request_stream */ 5:
                    message.requestStream = reader.string();
                    break;
                case /* google.protobuf.Timestamp registered_at */ 6:
                    message.registeredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.registeredAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolRegistrationAck, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.urn.v1.URN tool_urn = 1; */
        if (message.toolUrn)
            URN.internalBinaryWrite(message.toolUrn, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.tool.v1.ExecutionMode selected_mode = 2; */
        if (message.selectedMode !== 0)
            writer.tag(2, WireType.Varint).int32(message.selectedMode);
        /* int32 heartbeat_interval_seconds = 3; */
        if (message.heartbeatIntervalSeconds !== 0)
            writer.tag(3, WireType.Varint).int32(message.heartbeatIntervalSeconds);
        /* string execution_subject = 4; */
        if (message.executionSubject !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.executionSubject);
        /* string request_stream = 5; */
        if (message.requestStream !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.requestStream);
        /* google.protobuf.Timestamp registered_at = 6; */
        if (message.registeredAt)
            Timestamp.internalBinaryWrite(message.registeredAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolRegistrationAck
 */
export const ToolRegistrationAck = new ToolRegistrationAck$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolHeartbeat$Type extends MessageType<ToolHeartbeat> {
    constructor() {
        super("agency.tool.v1.ToolHeartbeat", [
            { no: 1, name: "tool_urn", kind: "message", T: () => URN, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "status", kind: "enum", T: () => ["agency.tool.v1.ToolStatus", ToolStatus, "TOOL_STATUS_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "active_calls", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 5, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "10", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "1024" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ToolHeartbeat>): ToolHeartbeat {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        message.activeCalls = 0;
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<ToolHeartbeat>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolHeartbeat): ToolHeartbeat {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.urn.v1.URN tool_urn */ 1:
                    message.toolUrn = URN.internalBinaryRead(reader, reader.uint32(), options, message.toolUrn);
                    break;
                case /* google.protobuf.Timestamp timestamp */ 2:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* agency.tool.v1.ToolStatus status */ 3:
                    message.status = reader.int32();
                    break;
                case /* int32 active_calls */ 4:
                    message.activeCalls = reader.int32();
                    break;
                case /* map<string, string> metadata */ 5:
                    this.binaryReadMap5(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: ToolHeartbeat["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ToolHeartbeat["metadata"] | undefined, val: ToolHeartbeat["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.tool.v1.ToolHeartbeat.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ToolHeartbeat, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.urn.v1.URN tool_urn = 1; */
        if (message.toolUrn)
            URN.internalBinaryWrite(message.toolUrn, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp timestamp = 2; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* agency.tool.v1.ToolStatus status = 3; */
        if (message.status !== 0)
            writer.tag(3, WireType.Varint).int32(message.status);
        /* int32 active_calls = 4; */
        if (message.activeCalls !== 0)
            writer.tag(4, WireType.Varint).int32(message.activeCalls);
        /* map<string, string> metadata = 5; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolHeartbeat
 */
export const ToolHeartbeat = new ToolHeartbeat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoteToolExecutionRequest$Type extends MessageType<RemoteToolExecutionRequest> {
    constructor() {
        super("agency.tool.v1.RemoteToolExecutionRequest", [
            { no: 1, name: "tool_urn", kind: "message", T: () => URN, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "harness_urn", kind: "message", T: () => URN, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "call", kind: "message", T: () => ToolCall, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 5, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 6, name: "timeout_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 600, gte: 1 } } } },
            { no: 7, name: "response_subject", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 8, name: "trace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { pattern: "^([0-9a-f]{32})?$" } } } },
            { no: 9, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } }
        ]);
    }
    create(value?: PartialMessage<RemoteToolExecutionRequest>): RemoteToolExecutionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.turnId = "";
        message.timeoutSeconds = 0;
        message.responseSubject = "";
        message.traceId = "";
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<RemoteToolExecutionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoteToolExecutionRequest): RemoteToolExecutionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.urn.v1.URN tool_urn */ 1:
                    message.toolUrn = URN.internalBinaryRead(reader, reader.uint32(), options, message.toolUrn);
                    break;
                case /* agency.urn.v1.URN harness_urn */ 2:
                    message.harnessUrn = URN.internalBinaryRead(reader, reader.uint32(), options, message.harnessUrn);
                    break;
                case /* agency.tool.v1.ToolCall call */ 3:
                    message.call = ToolCall.internalBinaryRead(reader, reader.uint32(), options, message.call);
                    break;
                case /* string session_id */ 4:
                    message.sessionId = reader.string();
                    break;
                case /* string turn_id */ 5:
                    message.turnId = reader.string();
                    break;
                case /* int32 timeout_seconds */ 6:
                    message.timeoutSeconds = reader.int32();
                    break;
                case /* string response_subject */ 7:
                    message.responseSubject = reader.string();
                    break;
                case /* string trace_id */ 8:
                    message.traceId = reader.string();
                    break;
                case /* map<string, string> metadata */ 9:
                    this.binaryReadMap9(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap9(map: RemoteToolExecutionRequest["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof RemoteToolExecutionRequest["metadata"] | undefined, val: RemoteToolExecutionRequest["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.tool.v1.RemoteToolExecutionRequest.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: RemoteToolExecutionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.urn.v1.URN tool_urn = 1; */
        if (message.toolUrn)
            URN.internalBinaryWrite(message.toolUrn, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.urn.v1.URN harness_urn = 2; */
        if (message.harnessUrn)
            URN.internalBinaryWrite(message.harnessUrn, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* agency.tool.v1.ToolCall call = 3; */
        if (message.call)
            ToolCall.internalBinaryWrite(message.call, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string session_id = 4; */
        if (message.sessionId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.sessionId);
        /* string turn_id = 5; */
        if (message.turnId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.turnId);
        /* int32 timeout_seconds = 6; */
        if (message.timeoutSeconds !== 0)
            writer.tag(6, WireType.Varint).int32(message.timeoutSeconds);
        /* string response_subject = 7; */
        if (message.responseSubject !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.responseSubject);
        /* string trace_id = 8; */
        if (message.traceId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.traceId);
        /* map<string, string> metadata = 9; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.RemoteToolExecutionRequest
 */
export const RemoteToolExecutionRequest = new RemoteToolExecutionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolDeregistrationRequest$Type extends MessageType<ToolDeregistrationRequest> {
    constructor() {
        super("agency.tool.v1.ToolDeregistrationRequest", [
            { no: 1, name: "tool_urn", kind: "message", T: () => URN, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 3, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ToolDeregistrationRequest>): ToolDeregistrationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<ToolDeregistrationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolDeregistrationRequest): ToolDeregistrationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.urn.v1.URN tool_urn */ 1:
                    message.toolUrn = URN.internalBinaryRead(reader, reader.uint32(), options, message.toolUrn);
                    break;
                case /* string reason */ 2:
                    message.reason = reader.string();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 3:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolDeregistrationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.urn.v1.URN tool_urn = 1; */
        if (message.toolUrn)
            URN.internalBinaryWrite(message.toolUrn, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string reason = 2; */
        if (message.reason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reason);
        /* google.protobuf.Timestamp timestamp = 3; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolDeregistrationRequest
 */
export const ToolDeregistrationRequest = new ToolDeregistrationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolDeregistrationAck$Type extends MessageType<ToolDeregistrationAck> {
    constructor() {
        super("agency.tool.v1.ToolDeregistrationAck", [
            { no: 1, name: "tool_urn", kind: "message", T: () => URN, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "deregistered_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ToolDeregistrationAck>): ToolDeregistrationAck {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ToolDeregistrationAck>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolDeregistrationAck): ToolDeregistrationAck {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.urn.v1.URN tool_urn */ 1:
                    message.toolUrn = URN.internalBinaryRead(reader, reader.uint32(), options, message.toolUrn);
                    break;
                case /* google.protobuf.Timestamp deregistered_at */ 2:
                    message.deregisteredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deregisteredAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolDeregistrationAck, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.urn.v1.URN tool_urn = 1; */
        if (message.toolUrn)
            URN.internalBinaryWrite(message.toolUrn, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deregistered_at = 2; */
        if (message.deregisteredAt)
            Timestamp.internalBinaryWrite(message.deregisteredAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolDeregistrationAck
 */
export const ToolDeregistrationAck = new ToolDeregistrationAck$Type();
